/* eslint-disable import/no-cycle */
import jwtDecode from 'jwt-decode';

import * as types from '../constants';
import { getAppConfig } from '.';
import { updateSessionStorage } from './common';
import { EXTERNAL_USER } from './constants';

/**
 * Returns decoded access token from Okta auth instance
 * @param {object} auth Okta auth instance
 * @returns {object} Decoded access token
 */
const getAccessToken = async auth => {
  const { host, path } = getAppConfig('server');
  const { redirectAfterLogout } = getAppConfig('login');
  if (typeof auth !== 'object' || typeof auth.getAccessToken !== 'function') {
    return {};
  }
  const token = await auth.getAccessToken();

  if (token || window.location.pathname.indexOf('.html') !== -1) {
    return jwtDecode(token);
  }
  window.location.href = `${host}${path}${redirectAfterLogout}`;
  return {};
};

/**
 * Returns current logged-in user permissions from Okta (groups via. token)
 * @param {object} auth Okta auth instance or groups array
 * @returns {array} Current logged-in user permissions
 */
const getUserPermissions = async auth => {
  // if authCheck if auth is user permissions array
  if (Array.isArray(auth)) {
    return auth;
  }

  // Get the token and return groups
  const token = await getAccessToken(auth);
  const groups = token.groups || null;
  return groups && Array.isArray(groups) ? groups : [];
};

const isUserExternal = () => {
  const userType = updateSessionStorage.getItem('user-type');
  if (userType) {
    return userType.toString().toLowerCase() === EXTERNAL_USER.toString().toLowerCase();
  }
  return false;
};

const checkForNotificationPermission = (notificationType, groups = []) => {
  if (
    notificationType.toLowerCase() === types.CONTRACT_NOTIFICATION ||
    notificationType.toLowerCase() === types.CONTRACTS.toLowerCase()
  ) {
    return groups.includes(types.DXP_FOOD_ACCGRP_CONTRACTS.toString().toLowerCase());
  }
  if (
    notificationType.toLowerCase() === types.ORDERS.toLowerCase() ||
    notificationType.toLowerCase() === types.ORDER_NOTIFICATION ||
    notificationType.toLowerCase() === types.ORDER_NOTIFICATION_ADDITIONAL
  ) {
    return groups.includes(types.DXP_FOOD_ACCGRP_ORDERS.toString().toLowerCase());
  }
  if (
    notificationType.toLowerCase() === types.DOCUMENTS.toLowerCase() ||
    notificationType.toLowerCase() === types.REMOVED_TECH_DOC_NOTIFICATION ||
    notificationType.toLowerCase() === types.UPDATED_TECH_DOC_NOTIFICATION ||
    notificationType.toLowerCase() === types.REMOVED_PROD_DOC_NOTIFICATION ||
    notificationType.toLowerCase() === types.UPDATED_PROD_DOC_NOTIFICATION
  ) {
    return groups.includes(types.DXP_FOOD_ACCGRP_DOCUMENTS.toString().toLowerCase());
  }
  return false;
};

export { checkForNotificationPermission, getUserPermissions as default, isUserExternal };
